var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsObject, IsString, IsUUID } from 'class-validator';
import { TrackingType } from '../enums/tracking-type.enum.js';
import { TrainingSessionItemFullSizeDto } from './training-session-item.full-size.dto.js';
export class TrainingSessionItemTrackingFullSizeDto {
    id;
    createdAt;
    updatedAt;
    eventTime;
    type;
    notes;
    trainingSessionItemId;
    trainingSessionItem;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemTrackingFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], TrainingSessionItemTrackingFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], TrainingSessionItemTrackingFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], TrainingSessionItemTrackingFullSizeDto.prototype, "eventTime", void 0);
__decorate([
    IsEnum(TrackingType),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemTrackingFullSizeDto.prototype, "type", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], TrainingSessionItemTrackingFullSizeDto.prototype, "notes", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], TrainingSessionItemTrackingFullSizeDto.prototype, "trainingSessionItemId", void 0);
__decorate([
    IsObject(),
    Type(() => TrainingSessionItemFullSizeDto),
    Exclude(),
    __metadata("design:type", TrainingSessionItemFullSizeDto)
], TrainingSessionItemTrackingFullSizeDto.prototype, "trainingSessionItem", void 0);
//# sourceMappingURL=training-session-item-tracking.full-size.dto.js.map